import { render, staticRenderFns } from "./NCTeacherLanding.vue?vue&type=template&id=c275e256&scoped=true&"
import script from "./NCTeacherLanding.vue?vue&type=script&lang=js&"
export * from "./NCTeacherLanding.vue?vue&type=script&lang=js&"
import style0 from "./NCTeacherLanding.vue?vue&type=style&index=0&id=c275e256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c275e256",
  null
  
)

export default component.exports